module.exports = __webpack_public_path__ + "img/logo.e1aa4ad8.png";